import {Association} from '../../../shared/models/association.model';
import {AssociationService} from '../../../shared/services/association.service';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

export class AssociationsDetailsResolver implements Resolve<Association> {

  constructor( @Inject(AssociationService) private service: AssociationService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Association> {
    return this.service.findById(+route.paramMap.get('id'));
  }
}
